var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},_vm._l((_vm.networksWithUrls),function(network){return _c('div',{key:network.id,staticClass:"social__icon"},[_vm._v("\n    "+_vm._s(network.name ? network.name.slice(0,2) : '')+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }